<div class="search-container" id="search-container">
  <span class="p-input-icon-left">
    <i class="pi pi-search"></i>
    <input
      #searchInput
      type="text"
      pInputText
      [(ngModel)]="searchText"
      (ngModelChange)="onSearch()"
      (keyup.enter)="onSearch()"
      placeholder="Search"
      class="p-inputtext-sm"
    />
    <p-progressSpinner *ngIf="loading" strokeWidth="3" />
  </span>

  <p-overlay
    [(visible)]="showResults"
    [showTransitionOptions]="'.12s cubic-bezier(0, 0, 0.2, 1)'"
    [hideTransitionOptions]="'.1s cubic-bezier(0.4, 0, 1, 1)'"
    [style]="{ width: '432px' }"
    styleClass="search-results-overlay"
  >
    <div class="search-results">
      <!-- Companies -->
      <div *ngIf="searchResult?.companies?.length" class="result-section">
        <div *ngFor="let company of searchResult!.companies" class="result-item">
          <a [routerLink]="['/company', company.businessCode]" class="flex align-content-start gap-2" (click)="onResultItemClick()">
            <i class="pi pi-building"></i>
            <div class="flex flex-column gap-2">
              <h3 [innerHTML]="company.legalName | highlight : searchText"></h3>
              <div [innerHTML]="joinValues(company.businessCode, company.signer, company.emailAddress) | highlight : searchText"></div>
            </div>
          </a>
        </div>
      </div>

      <!-- Foreign Nationals -->
      <div *ngIf="searchResult?.foreignNationals?.length" class="result-section">
        <div *ngFor="let fn of searchResult!.foreignNationals" class="result-item">
          <a [routerLink]="['/foreign-national', fn.businessCode, 'dashboard']" class="flex align-content-start gap-2" (click)="onResultItemClick()">
            <i class="pi pi-user"></i>
            <div class="flex flex-column gap-2">
              <h3 [innerHTML]="fn.fullName | highlight : searchText"></h3>
              <div [innerHTML]="joinValues(fn.company, toPTDateString(fn.birthDate)) | highlight : searchText"></div>
              <div [innerHTML]="joinValues(fn.mobile, fn.businessCode, fn.email) | highlight : searchText"></div>
            </div>
          </a>
        </div>
      </div>

      <!-- Matters -->
      <div *ngIf="searchResult?.matters?.length" class="result-section">
        <div *ngFor="let matter of searchResult!.matters" class="result-item">
          <a [routerLink]="['/matter', matter.businessCode]" class="flex align-content-start gap-2" (click)="onResultItemClick()">
            <i class="pi pi-briefcase"></i>
            <div class="flex flex-column gap-2">
              <h3 [innerHTML]="matter.matterName | highlight : searchText"></h3>
              <div [innerHTML]="joinValues(matter.fnFullName, matter.fnBusinessCode, matter.fnEmail) | highlight : searchText"></div>
              <span [innerHTML]="joinValues(matter.primReceiptNumber, matter.businessCode) | highlight : searchText"></span>
            </div>
          </a>
        </div>
      </div>

      <!-- Contacts -->
      <div *ngIf="searchResult?.contacts?.length" class="result-section">
        <div *ngFor="let contact of searchResult!.contacts" class="result-item">
          <a [routerLink]="['/company', contact.companyBusinessCode, 'users', contact.id]" class="flex align-content-start gap-2" (click)="onResultItemClick()">
            <i class="pi pi-id-card"></i>
            <div class="flex flex-column gap-2">
              <h3 [innerHTML]="contact.fullName | highlight : searchText"></h3>
              <div [innerHTML]="joinValues(contact.company, contact.companyBusinessCode) | highlight : searchText"></div>
              <div [innerHTML]="joinValues(contact.phone, contact.email) | highlight : searchText"></div>
            </div>
          </a>
        </div>
      </div>

      <!-- Locations -->
      <div *ngIf="searchResult?.locations?.length" class="result-section">
        <div *ngFor="let location of searchResult!.locations" class="result-item">
          <a [routerLink]="['/company', location.companyBusinessCode, 'locations']" class="flex align-content-start gap-2" (click)="onResultItemClick()">
            <i class="pi pi-map-marker"></i>
            <div class="flex flex-column gap-2">
              <h3 [innerHTML]="(location.locationTitle || joinValues(location.street, location.city, location.state)) | highlight : searchText"></h3>
              <div *ngIf="location.locationTitle" [innerHTML]="joinValues(location.street, location.city, location.state) | highlight : searchText"></div>
              <div [innerHTML]="joinValues(location.company, location.companyBusinessCode) | highlight : searchText"></div>
            </div>
          </a>
        </div>
      </div>

      <div *ngIf="!hasResults" class="no-results">No results found</div>

      <!-- More Results -->
      <div *ngIf="hasResults" class="more-results">
        <a [routerLink]="['/advanced-search']" [queryParams]="{ q: searchText }" (click)="onResultItemClick()"> More Results </a>
      </div>
    </div>
  </p-overlay>
</div>
